import { useEffect } from 'react';

/**
 * Custom hook to debounce saving data whenever it changes and is marked as modified.
 * @param {object} data The object state to be saved (e.g., headOffice).
 * @param {boolean} isModified Flag indicating if the data has changed.
 * @param {function} saveFn The asynchronous function to call to perform the save.
 * @param {boolean} isLoading Flag indicating if a save is currently in progress.
 * @param {number} timeout Delay in milliseconds before triggering the save.
 */

function useAutoSave(data, isModified, saveFn, isLoading, timeout = 1000) {
    useEffect(() => {
        // If not modified, or currently loading, or if we have no data: stop.
        if (!isModified || isLoading || !data) {
            return;
        }

        const timeoutId = setTimeout(() => {
            saveFn(data);
        }, timeout);

        return () => clearTimeout(timeoutId);
    }, [data, isModified, saveFn, isLoading, timeout]);
}

export default useAutoSave;